// extracted by mini-css-extract-plugin
module.exports = {"ant-col-xl-48":"index_ant-col-xl-48-iEGKG","ant-col-xl-96":"index_ant-col-xl-96-7vcGJ","nprogress-spinner":"index_nprogress-spinner-2rnEH"};